import React, {useMemo} from "react"
import {Divider, Grid, Stack, styled, Typography} from "@mui/material"

const MyDivider = styled(Divider)((props) => ({
    borderColor: props.color,
    marginBottom: "24px",
    marginTop: "8px",
}))

const flexBasis = "358px"

const fields = [
    {
        title: "Bruttoeinkommen",
        key: "bruttoeinkommen",
    },
    {
        title: "Steuern",
        key: "steuern",
    },
    {
        title: "Rentenversicherung",
        key: "rentenversicherung",
    },
    {
        title: "Arbeitslosenversicherung",
        key: "arbeitslosenversicherung",
    },
    {
        title: "Krankenversicherung",
        key: "krankenversicherung",
    },
    {
        title: "Pflegeversicherung",
        key: "pflegebeitrag",
    },
    {
        title: "Nettoeinkommen",
        key: "nettoeinkommen",
    },
    {
        title: "Erhöhung",
        key: "differenzAktuellesNettoeinkommen",
    },
]

//Nach kompletter Umsetzung sollte man prüfen, ob dieses Widget auch allgemeiner gelößt werden kann.
//Zeitdruck und offene Punkte hindern die Umsetzung gerade.
const WidgetTable = ({widget, getDataFromPointer}) => {
    const {connections, color = "#5c6771"} = widget
    const pointer = useMemo(
        () => connections?.origin?.pointer,
        [connections?.origin?.pointer],
    )
    const data = getDataFromPointer(pointer)

    return data ? <Stack width="100%">
        <Grid container>
            <Grid flexBasis={flexBasis}/>
            {data.map(data => <Grid flex={1} key={data.date}>
                <Typography textAlign="right" color={color}>{data.date}</Typography>
            </Grid>)}
        </Grid>
        <Grid>
            <MyDivider color={color}/>
        </Grid>
        <Stack spacing="12px">
            {fields.map((field) => <Grid container key={field.key}>
                <Grid flexBasis={flexBasis}>
                    <Typography>{field.title}</Typography>
                </Grid>
                {data.map(data => <Grid flex={1} key={`${field.key}-${data.date}`}>
                    <Typography textAlign="right" fontWeight="bold">{data[field.key]} €</Typography>
                </Grid>)}
            </Grid>)}
        </Stack>
    </Stack> : <></>
}

export default WidgetTable